var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1426 18.3337C12.3926 18.3337 14.476 17.5003 16.0593 15.917C16.3926 15.5837 16.3926 15.0837 16.0593 14.7503C15.726 14.417 15.226 14.417 14.8926 14.7503C13.5593 16.0003 11.8926 16.667 10.1426 16.667C6.47595 16.667 3.47595 13.667 3.47595 10.0003C3.47595 6.33366 6.47595 3.33366 10.1426 3.33366C11.8926 3.33366 13.5593 4.00033 14.8926 5.25033C15.5593 5.91699 16.976 7.58366 17.0593 7.66699C17.3926 8.00033 17.8926 8.08366 18.226 7.75033C18.5593 7.41699 18.6426 6.91699 18.3093 6.58366C18.226 6.50033 16.8093 4.83366 16.0593 4.16699C14.476 2.50033 12.3926 1.66699 10.1426 1.66699C5.55928 1.66699 1.80928 5.41699 1.80928 10.0003C1.80928 14.5837 5.55928 18.3337 10.1426 18.3337Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3089 7.91699H17.6423C18.1423 7.91699 18.4756 7.58366 18.4756 7.08366V3.75033C18.4756 3.25033 18.1423 2.91699 17.6423 2.91699C17.1423 2.91699 16.8089 3.25033 16.8089 3.75033V6.25033H14.3089C13.8089 6.25033 13.4756 6.58366 13.4756 7.08366C13.4756 7.58366 13.8089 7.91699 14.3089 7.91699Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.ec54f4a696e5345c302e17ad23235603.svg";
export { ForwardRef as ReactComponent };